import React from "react";
import { ArrowLeft, Search, User } from "lucide-react";
import { useAppContext } from "../../context/AppContext";

export default function DmInbox({
  setShowDmInbox,
  setShowFollowersModal,
  inboxRooms,
  setActiveDmRoom,
}: any) {
  const { t, user } = useAppContext();

  return (
    <div className="fixed inset-0 bg-[var(--bg-main)] z-[400] animate-fade-in flex flex-col">
      <div className="bg-[var(--bg-card)] border-b border-[var(--border-color)] px-5 py-4 shrink-0 pt-12 shadow-sm relative z-40 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <button
            onClick={() => setShowDmInbox(false)}
            className="active:scale-95 text-[var(--text-main)]"
          >
            <ArrowLeft size={20} />
          </button>
          <h2 className="font-extrabold text-xl text-[var(--text-main)]">
            {t.dm}
          </h2>
        </div>
        <button
          onClick={() => setShowFollowersModal(true)}
          className="p-2 bg-[var(--bg-soft)] border border-[var(--border-color)] rounded-full text-[#a073e7] shadow-sm"
        >
          <Search size={18} />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-2">
        {inboxRooms.length === 0 ? (
          <div className="text-center py-10 text-[var(--text-muted)] font-bold text-sm">
            {t.noDm}
          </div>
        ) : null}
        {inboxRooms.map((msg: any) => {
          const isMeSender = msg.senderId === user?.uid;
          const otherId = isMeSender ? msg.recipientId : msg.senderId;
          const otherName = isMeSender ? msg.recipientName : msg.senderName;
          const otherPhoto = isMeSender ? msg.recipientPhoto : msg.senderPhoto;
          const isUnread = !isMeSender && !msg.read;
          return (
            <div
              key={msg.roomId}
              onClick={() =>
                setActiveDmRoom({
                  id: msg.roomId,
                  otherUserId: otherId,
                  otherUserName: otherName,
                  otherUserPhoto: otherPhoto,
                })
              }
              className={`flex gap-3 p-4 rounded-2xl border items-center active:scale-95 transition-all cursor-pointer ${
                isUnread
                  ? "bg-[var(--bg-card)] border-[var(--red-text)] shadow-sm"
                  : "bg-[var(--bg-soft)] border-[var(--border-color)]"
              }`}
            >
              <div className="w-12 h-12 rounded-full bg-[var(--accent-soft)] flex items-center justify-center overflow-hidden shrink-0 border border-[var(--bg-card)] shadow-sm relative">
                {otherPhoto ? (
                  <img
                    src={otherPhoto}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <User size={20} className="text-[#a073e7]" />
                )}
                {isUnread && (
                  <span className="absolute top-0 right-0 w-3 h-3 bg-[var(--red-text)] rounded-full border-2 border-[var(--bg-card)]" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-center mb-1">
                  <h4
                    className={`font-bold text-sm truncate ${
                      isUnread
                        ? "text-[var(--text-main)]"
                        : "text-[var(--text-muted)]"
                    }`}
                  >
                    {otherName}
                  </h4>
                  <span className="text-[10px] text-[var(--text-muted)]">
                    {msg.time}
                  </span>
                </div>
                <p
                  className={`text-xs truncate ${
                    isUnread
                      ? "font-bold text-[var(--text-main)]"
                      : "text-[var(--text-muted)]"
                  }`}
                >
                  {isMeSender ? `${t.you} ` : ""}
                  {msg.text}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
